export default "__VITE_ASSET__CgKHMA2j__"